import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToasterService } from '@auto-editor/feature-toaster';
import { HttpErrorsService } from '@auto-editor/core/errors/http-errors';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private toasterService: ToasterService,
    private httpErrorsService: HttpErrorsService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    try {
      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          const statusCode = error?.status;
          const reason = error?.error?.error;
          if (this.httpErrorsService._isInstanceOfClientError(error?.error)) {
            // BE handled errors
            if (statusCode === 401 || statusCode === 403) {
              if (reason !== 'tokenAuthenticationFailed' && reason !== 'notAuthenticated') {
                this.toasterService.error(this.httpErrorsService.getErrorMessage(error?.error?.error_description));
              } else if (reason !== 'invalidEmailFormat') {
                this.toasterService.error(this.httpErrorsService.getErrorMessage(error?.error?.error_description));
              }
            } else if (statusCode === 400) {
              this.toasterService.error(this.httpErrorsService.getErrorMessage(reason));
            } else if (statusCode === 429) {
              return throwError(error); //Mostraremos pro pantalla ppor qué pasa eso
            } else if (statusCode === 599) {
              return throwError(error);
            }
          } else {
            // unhandled errors
            this.toasterService.error(`Message: ${error?.message} Status: ${error.status}`);
          }
          return throwError(error);
        })
      );
    } catch {
      return next.handle(request);
    }
  }
}
